export enum INVOICE_TYPE {
  PLAN_ORDER = 'plan-order',
  CAMPAIGN = 'campaign',
}
